import React from 'react';
import { Routes, Route } from 'react-router-dom';
import AgencyPage from './pages/AgencyPage';
import PackageDetailPage from './pages/PackageDetailPage';
import { useAgencyInfo } from './hooks/useAgencyInfo';
import { NavigationProvider, useNavigation } from './contexts/NavigationContext';

function AppContent() {
  const { loading, error } = useAgencyInfo();
  const { currentView } = useNavigation();

  if (loading) {
    return <div>Chargement...</div>;
  }

  if (error) {
    console.error('Erreur lors du chargement des informations de l\'agence:', error);
  }

  if (currentView.view === 'package') {
    return <PackageDetailPage packageId={currentView.packageId} />;
  }

  return <AgencyPage />;
}

function AppWithNav() {
  return (
    <NavigationProvider>
      <AppContent />
    </NavigationProvider>
  );
}

export default function App() {
  return (
    <div className="min-h-screen bg-gray-50">
      <Routes>
        {/*
          Route dédiée : sinon useParams().id est vide avec path="/*" seul
          et /agence/2 déclenchait agencyPageData(subdomain: "localhost") → erreur.
        */}
        <Route path="/agence/:id" element={<AppWithNav />} />
        <Route path="*" element={<AppWithNav />} />
      </Routes>
    </div>
  );
}
